export const PERMISSION = {
    MANAGE_ATTENDANCE_SETTINGS: 'manage_attendance_settings',
    MANAGE_BUDGET: 'manage_budget',
    MANAGE_TIMECARD: 'manage_timecard',
    MANAGE_NETWORK: 'manage_network',
    MANAGE_CERTIFICATE: 'manage_certs',
    MANAGE_BILLING: 'manage_billing',
    MANAGE_TIMECLOCKS: 'manage_timeclocks',
    MANAGE_AVAILABILITY: 'manage_availability',
    MANAGE_SCHEDULE: 'manage_schedule',
    MANAGE_TIMEOFF: 'manage_timeoff',
    MANAGE_HIRING: 'manage_hiring',
    MANAGE_DELIVERIES: 'manage_deliveries',
};
